import { FC } from 'react';
import { Cross } from '@edikk-edikk/icon/Cross';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useStoryDetailListWrapperContext } from '#advertStory/detail-list-wrapper';

const StoryDetailHeaderCloseButton: FC = () => {
  const { hide } = useStoryDetailListWrapperContext();

  return (
    <Button variant={ButtonVariant.unstyled} onClick={hide}>
      <SvgIcon Component={Cross} width={16} height={16} isNeedWrap={false} isWithoutFill />
    </Button>
  );
};

export { StoryDetailHeaderCloseButton };
